import {Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography} from "@mui/material";
import {WordAvail, RecordMetaData} from "../../services/model";


interface WordDropdownProps {
    wordAvail: WordAvail,
    setId: (id: string) => void
    choicesList: RecordMetaData[],
    id: string,
    singleWordRecord: (word: string) => void
}

export default function WordDropdown(props: WordDropdownProps) {

    function getDropdownColor(availability: string) {
        console.log(`word=${props.wordAvail.word}, props.wordAvail.availability=${props.wordAvail.availability}, record.availability=${availability}`)
        if (availability === "MYSELF") {
            return "#0930b0";
        } else if (availability === "PUBLIC") {
            return "#d39104";
        } else if (availability === "FRIENDS") {
            return "#a7e006";
        } else if (availability === "SCOPE") {
            return "#008609";
        }
    }

    return (
        <FormControl variant="filled" size="small">
            <InputLabel id="demo-simple-select-label">
                <Grid container direction={"row"} wrap={"nowrap"}>
                    {props.choicesList && props.choicesList.length > 1 &&
                        <Grid mr={1} border={1} bgcolor={"darkgrey"} color={"#577ee0"}>
                            {props.choicesList.length}
                        </Grid>
                    }
                    <Grid>
                        {props.wordAvail.word.toUpperCase()}
                    </Grid>
                </Grid>
            </InputLabel>
            {props.wordAvail.availability === "INVALID" ?
                <Select
                    size={"medium"}
                    variant={"standard"}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    autoWidth
                    value={props.wordAvail.availability === "INVALID" ? "invalid" :
                        props.wordAvail.availability === "AVAILABLE" ? props.id : 'record'}
                    label={props.wordAvail.word.toUpperCase()}
                    IconComponent={() => null}
                    onChange={e => props.setId(e.target.value)}
                    sx={{textAlign: "center"}}
                >
                    <MenuItem key={'invalid'} value={'invalid'}>
                        <Grid container bgcolor={"#881111"}>
                            <Grid>
                                <Typography sx={{textDecoration: "line-through"}}>INVALID</Typography>
                            </Grid>
                        </Grid>
                    </MenuItem>
                </Select>
                :
                <Select
                    size={"medium"}
                    variant={"standard"}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    autoWidth
                    value={props.wordAvail.availability === "AVAILABLE" ? props.id : 'record'}
                    label={props.wordAvail.word.toUpperCase()}
                    IconComponent={() => null}
                    onChange={e => props.setId(e.target.value)}
                    sx={{textAlign: "center"}}
                >
                    {props.wordAvail.availability === "AVAILABLE" &&
                        props.choicesList.map(wmd =>
                            <MenuItem key={wmd.id} value={wmd.id}>
                                <Grid container direction={"column"} bgcolor={getDropdownColor(wmd.availability)}>
                                    <Grid>
                                        <Typography>{wmd.creator}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography>{wmd.tag}</Typography>
                                    </Grid>
                                </Grid>
                            </MenuItem>
                        )
                    }
                    <MenuItem key={'record'} value={'record'}>
                        <Box onClick={() => props.singleWordRecord(props.wordAvail.word)} sx={{ width: '100%' }}>
                            <Grid container bgcolor={"#b43535"}>
                                <Grid>
                                    <Typography>record</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </MenuItem>
                </Select>
            }
        </FormControl>
    )
}